<template>
  <ModalForm
    v-model="formData"
    class="modal--md"
    :title="title"
    text-btn-confirm="Сохранить"
    @request="onRequest"
    @reject="onReject"
  >
    <div class="column gap-s mb-20">
      <AttachmentFilesList
        v-if="mode === 'change'"
        :files="[item]"
        with-preview
        show-date
      />

      <InfoTextBlock label-text="Материал" :text="materialName" />
      <InfoTextBlock label-text="d пров." :text="dWire" />

      <VInputFiles
        v-model="formData.files"
        class="files-certificate"
        label="Файлы"
        with-preview
      />
    </div>
  </ModalForm>
</template>

<script>
import ModalForm from '@/components/ui/Modal/ModalForm.vue'
import VInputFiles from '@/components/Form/VInputFiles/VInputFiles.vue'
import InfoTextBlock from '@/components/ui/AppInfoTextBlock.vue'
import AttachmentFilesList from '@/components/files/AttachmentFiles/AttachmentFilesList.vue'

export default {
  name: 'ModalCertificateFile',
  components: { AttachmentFilesList, InfoTextBlock, VInputFiles, ModalForm },
  props: {
    // 'add' | 'change'
    mode: {
      type: String,
      default: 'add'
    },
    /**
     * Заголовок модалки
     */
    title: {
      type: String,
      default: 'Добавить сертификат'
    },
    /**
     * Текущая строка (d.пров. или файл)
     */
    item: {
      type: Object,
      default: null
    },
    /**
     * Родительская строка (d.пров.)
     */
    parentItem: {
      type: Object,
      default: null
    },
    /**
     * Экшен для отправки данных
     */
    action: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      formData: {
        files: null
      }
    }
  },
  computed: {
    /**
     * Имя материала для отображения
     */
    materialName () {
      return this.mode === 'change' ? this.parentItem?.name : this.item?.name
    },
    /**
     * Диаметр проволоки для отображения
     */
    dWire () {
      return this.mode === 'change' ? this.parentItem?.d_wire : this.item?.d_wire
    }
  },
  methods: {
    /**
     * Обработка отправки формы
     * @param {Object} data - данные формы
     */
    async onRequest (data) {
      try {
        this.$store.commit('SET_IS_SENDING_REQUEST_MODAL')
        let params = { files: data.files }

        if (this.mode === 'change') {
          params = {
            ...params,
            file_id: this.item?.id
          }
        }
        console.log(params)
        // id для экшена: если есть parentItem, используем его id, иначе item.id
        const id = this.parentItem?.id || this.item?.id
        const response = await this.action({ id: id, data: params })
        if (response?.status !== 200) return

        this.$emit('loadList')
        this.onReject()
      } finally {
        this.$store.commit('SET_IS_SENDING_REQUEST_MODAL', false)
      }
    },

    /**
     * Закрытие модалки
     */
    onReject () {
      this.$emit('reject')
    },

    customValidation () {
      return false
    }
  }
}
</script>

<style lang="scss">
.files-certificate .attachment-files {
  flex-direction: column;
}
</style>
